import { StandardWebFormMoreSettings } from './StandardWebFormMoreSettings'

export const NumberWebFormMoreSettings = entry => {
  return <StandardWebFormMoreSettings decimalPlace={false} {...entry} />
}
